import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var questionApiCalls = {
  postQuestion: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_QUESTION_REQUEST, ActionTypes.POST_QUESTION_SUCCESS, ActionTypes.POST_QUESTION_FAILURE, ActionTypes.RESET_POST_QUESTION]
  })
};
export default questionApiCalls;